import { render } from "./debitor-receipt.vue?vue&type=template&id=77b60b68&scoped=true"
import script from "./debitor-receipt.vue?vue&type=script&lang=js"
export * from "./debitor-receipt.vue?vue&type=script&lang=js"

import "./debitor-receipt.vue?vue&type=style&index=0&id=77b60b68&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b60b68"]])

export default __exports__